import { Chart as ChartJS, registerables } from 'chart.js';
import * as Chart from 'react-chartjs-2';
ChartJS.register(...registerables);
export { Chart };
